import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("span", null, [
    /*#__PURE__*/ _createTextVNode("Name"),
    /*#__PURE__*/ _createElementVNode("span", { class: "text-error" }, "*")
], -1);
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("span", null, [
    /*#__PURE__*/ _createTextVNode("Email"),
    /*#__PURE__*/ _createElementVNode("span", { class: "text-error" }, "*")
], -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("span", null, [
    /*#__PURE__*/ _createTextVNode("Country"),
    /*#__PURE__*/ _createElementVNode("span", { class: "text-error" }, "*")
], -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("span", null, [
    /*#__PURE__*/ _createTextVNode("Message"),
    /*#__PURE__*/ _createElementVNode("span", { class: "text-error" }, "*")
], -1);
const _hoisted_5 = ["href"];
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("span", { class: "text-error" }, "*", -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("small", { class: "text-caption text-medium-emphasis" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "text-error" }, "*"),
    /*#__PURE__*/ _createTextVNode(" indicates required field")
], -1);
import ShortPartsList from './ShortPartsList.vue';
import { reactive, ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'RequestForm',
    props: {
        config: {},
        sparts: {},
        isOpen: { type: Boolean }
    },
    emits: {
        toggleSpart: (spart) => true,
        refresh: () => true,
        'update:isOpen': (value) => true,
    },
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const quoteRules = {
            name: [
                (v) => !!v || 'Name is required',
            ],
            email: [
                (v) => !!v || 'E-mail is required',
                (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ],
            phone: [
            //(v: string) => !!v || 'Phone is required',
            ],
            company: [
            //(v: string) => !!v || 'Company is required',
            ],
            country: [
                (v) => !!v || 'Country is required',
            ],
            message: [
                (v) => !!v || 'Message is required',
            ],
            acceptedTerms: [
                v => !!v || 'You must agree to the terms and conditions',
            ],
        };
        const quote = reactive({
            name: '',
            email: '',
            phone: '',
            company: '',
            country: '',
            message: '',
            acceptedTerms: false,
        });
        const response = ref(null);
        const submitting = ref(false);
        const formEl = ref(null);
        watch(() => props.isOpen, (isOpen) => {
            if (isOpen) {
                response.value = null;
            }
        });
        async function submitRequest() {
            var _a;
            if (submitting.value) {
                return;
            }
            const validation = await ((_a = formEl.value) === null || _a === void 0 ? void 0 : _a.validate());
            if (!(validation === null || validation === void 0 ? void 0 : validation.valid)) {
                return;
            }
            submitting.value = true;
            try {
                const resp = await (await window.fetch(props.config.rest.endpoints.request_quote, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': props.config.rest.nonce,
                        'Accept': 'application/json',
                    },
                    body: JSON.stringify({
                        session_token: props.config.session_token,
                        name: quote.name,
                        email: quote.email,
                        phone: quote.phone,
                        company: quote.company,
                        country: typeof quote.country === 'string' ? quote.country : quote.country.code,
                        message: quote.message,
                        sparts: props.sparts.map(spart => {
                            const cloned = JSON.parse(JSON.stringify(spart));
                            cloned.bundled = [];
                            return cloned;
                        }),
                        windowWidth: window.innerWidth,
                    }),
                })).json();
                if (resp.success && !resp.error) {
                    response.value = {
                        success: {
                            title: resp.success_title || 'Request submitted!',
                            text: resp.success_text || 'Your request has been submitted successfully. We will get back to you as soon as possible.',
                        },
                    };
                }
                else {
                    throw resp;
                }
            }
            catch (err) {
                console.error(err);
                response.value = {
                    error: {
                        title: err.error_title || 'Failed to submit request',
                        text: err.error_text || 'An error occurred while submitting your request. Please try again later.',
                    }
                };
            }
            submitting.value = false;
        }
        function close() {
            var _a;
            emit('update:isOpen', false);
            if ((_a = response.value) === null || _a === void 0 ? void 0 : _a.success) {
                refresh();
            }
        }
        function refresh() {
            quote.name = '';
            quote.email = '';
            quote.phone = '';
            quote.company = '';
            quote.country = '';
            quote.message = '';
            quote.acceptedTerms = false;
            emit('refresh');
        }
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_empty_state = _resolveComponent("v-empty-state");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_progress_linear = _resolveComponent("v-progress-linear");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_dialog = _resolveComponent("v-dialog");
            const _component_v_spacer = _resolveComponent("v-spacer");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_combobox = _resolveComponent("v-combobox");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_checkbox = _resolveComponent("v-checkbox");
            const _component_v_form = _resolveComponent("v-form");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            return (_openBlock(), _createBlock(_component_v_dialog, {
                "model-value": _ctx.isOpen,
                "onUpdate:modelValue": close,
                "max-width": "600"
            }, {
                default: _withCtx(({ isActive }) => [
                    (response.value)
                        ? (_openBlock(), _createBlock(_component_v_card, {
                            key: 0,
                            class: "respCard"
                        }, {
                            append: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                    icon: "mdi-close",
                                    onClick: close,
                                    variant: "text"
                                })
                            ]),
                            default: _withCtx(() => [
                                (response.value.error)
                                    ? (_openBlock(), _createBlock(_component_v_empty_state, {
                                        key: 0,
                                        title: response.value.error.title,
                                        text: response.value.error.text,
                                        icon: "mdi-alert-circle-outline",
                                        color: "error"
                                    }, {
                                        actions: _withCtx(() => [
                                            _createVNode(_component_v_btn, {
                                                variant: "flat",
                                                color: "duskBlue",
                                                "prepend-icon": "mdi-reload",
                                                ripple: "",
                                                onClick: _cache[0] || (_cache[0] = ($event) => (response.value = null))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(" Try again ")
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_btn, {
                                                variant: "flat",
                                                ripple: "",
                                                onClick: close
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(" Close ")
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }, 8, ["title", "text"]))
                                    : (response.value.success)
                                        ? (_openBlock(), _createBlock(_component_v_empty_state, {
                                            key: 1,
                                            title: response.value.success.title,
                                            text: response.value.success.text,
                                            icon: "mdi-check-circle-outline",
                                            color: "success"
                                        }, {
                                            actions: _withCtx(() => [
                                                _createVNode(_component_v_btn, {
                                                    variant: "flat",
                                                    color: "duskBlue",
                                                    ripple: "",
                                                    onClick: close
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(" Close ")
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }, 8, ["title", "text"]))
                                        : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : (_openBlock(), _createBlock(_component_v_card, {
                            key: 1,
                            title: "Request a quote",
                            "prepend-icon": "mdi-invoice-text-send-outline",
                            loading: submitting.value,
                            disabled: submitting.value
                        }, {
                            loader: _withCtx(({ isActive }) => [
                                _createVNode(_component_v_progress_linear, {
                                    active: isActive,
                                    color: "duskBlue",
                                    height: "4",
                                    indeterminate: ""
                                }, null, 8, ["active"])
                            ]),
                            append: _withCtx(() => [
                                (_ctx.sparts.length)
                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 0,
                                        "prepend-icon": "mdi-attachment",
                                        variant: "text",
                                        ripple: ""
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.sparts.length) + " part", 1),
                                            (_ctx.sparts.length > 1)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createTextVNode("s")
                                                ], 64))
                                                : _createCommentVNode("", true),
                                            _createTextVNode(" selected "),
                                            _createVNode(_component_v_dialog, {
                                                activator: "parent",
                                                "max-width": "500"
                                            }, {
                                                default: _withCtx(({ isActive }) => [
                                                    _createVNode(_component_v_card, {
                                                        "prepend-icon": "mdi-pencil",
                                                        title: "Selected parts"
                                                    }, {
                                                        append: _withCtx(() => [
                                                            _createVNode(_component_v_btn, {
                                                                icon: "mdi-close",
                                                                onClick: ($event) => (isActive.value = false),
                                                                variant: "text"
                                                            }, null, 8, ["onClick"])
                                                        ]),
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_card_text, null, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(ShortPartsList, {
                                                                        sparts: _ctx.sparts,
                                                                        onToggleSpart: _cache[1] || (_cache[1] = ($event) => (emit('toggleSpart', $event)))
                                                                    }, null, 8, ["sparts"])
                                                                ]),
                                                                _: 1
                                                            }),
                                                            _createVNode(_component_v_card_actions, null, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_v_btn, {
                                                                        onClick: ($event) => { isActive.value = false; emit('update:isOpen', false); },
                                                                        "prepend-icon": "mdi-chevron-left"
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createTextVNode("Search for more")
                                                                        ]),
                                                                        _: 2
                                                                    }, 1032, ["onClick"]),
                                                                    _createVNode(_component_v_btn, {
                                                                        onClick: ($event) => (isActive.value = false)
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createTextVNode("Close")
                                                                        ]),
                                                                        _: 2
                                                                    }, 1032, ["onClick"])
                                                                ]),
                                                                _: 2
                                                            }, 1024)
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ]),
                                                _: 2
                                            }, 1024)
                                        ]),
                                        _: 2
                                    }, 1024))
                                    : (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 1,
                                        "prepend-icon": "mdi-attachment",
                                        variant: "text",
                                        disabled: ""
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode("No parts selected")
                                        ]),
                                        _: 1
                                    })),
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_btn, {
                                    icon: "mdi-close",
                                    onClick: close,
                                    variant: "text"
                                })
                            ]),
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_form, {
                                            onSubmit: _cache[9] || (_cache[9] = _withModifiers(($event) => (submitRequest()), ["prevent"])),
                                            ref_key: "formEl",
                                            ref: formEl
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_row, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_col, null, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_text_field, {
                                                                    modelValue: quote.name,
                                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((quote.name) = $event)),
                                                                    rules: quoteRules.name,
                                                                    "prepend-inner-icon": "mdi-account",
                                                                    variant: "outlined",
                                                                    density: "comfortable",
                                                                    required: ""
                                                                }, {
                                                                    label: _withCtx(() => [
                                                                        _hoisted_1
                                                                    ]),
                                                                    _: 1
                                                                }, 8, ["modelValue", "rules"])
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_row, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_col, null, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_text_field, {
                                                                    modelValue: quote.email,
                                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((quote.email) = $event)),
                                                                    rules: quoteRules.email,
                                                                    "prepend-inner-icon": "mdi-email",
                                                                    variant: "outlined",
                                                                    density: "comfortable",
                                                                    required: ""
                                                                }, {
                                                                    label: _withCtx(() => [
                                                                        _hoisted_2
                                                                    ]),
                                                                    _: 1
                                                                }, 8, ["modelValue", "rules"])
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_row, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_col, null, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_text_field, {
                                                                    modelValue: quote.phone,
                                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((quote.phone) = $event)),
                                                                    rules: quoteRules.phone,
                                                                    "prepend-inner-icon": "mdi-phone",
                                                                    label: "Phone",
                                                                    variant: "outlined",
                                                                    density: "comfortable"
                                                                }, null, 8, ["modelValue", "rules"])
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_row, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                            cols: "12",
                                                            sm: "5"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_combobox, {
                                                                    modelValue: quote.country,
                                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((quote.country) = $event)),
                                                                    items: _ctx.config.countries,
                                                                    rules: quoteRules.country,
                                                                    "prepend-inner-icon": "mdi-earth",
                                                                    "item-title": "name",
                                                                    "item-value": "code",
                                                                    variant: "outlined",
                                                                    density: "comfortable",
                                                                    required: ""
                                                                }, {
                                                                    label: _withCtx(() => [
                                                                        _hoisted_3
                                                                    ]),
                                                                    _: 1
                                                                }, 8, ["modelValue", "items", "rules"])
                                                            ]),
                                                            _: 1
                                                        }),
                                                        _createVNode(_component_v_col, {
                                                            cols: "12",
                                                            sm: "7"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_text_field, {
                                                                    modelValue: quote.company,
                                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((quote.company) = $event)),
                                                                    rules: quoteRules.company,
                                                                    "prepend-inner-icon": "mdi-domain",
                                                                    label: "Company",
                                                                    variant: "outlined",
                                                                    density: "comfortable"
                                                                }, null, 8, ["modelValue", "rules"])
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_row, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_col, null, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_textarea, {
                                                                    modelValue: quote.message,
                                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((quote.message) = $event)),
                                                                    rules: quoteRules.message,
                                                                    "prepend-inner-icon": "mdi-message-text",
                                                                    variant: "outlined",
                                                                    density: "comfortable",
                                                                    required: ""
                                                                }, {
                                                                    label: _withCtx(() => [
                                                                        _hoisted_4
                                                                    ]),
                                                                    _: 1
                                                                }, 8, ["modelValue", "rules"]),
                                                                _createVNode(_component_v_checkbox, {
                                                                    modelValue: quote.acceptedTerms,
                                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((quote.acceptedTerms) = $event)),
                                                                    rules: quoteRules.acceptedTerms,
                                                                    title: "I agree to the terms and conditions",
                                                                    dense: ""
                                                                }, {
                                                                    label: _withCtx(() => [
                                                                        _createElementVNode("div", null, [
                                                                            _createTextVNode("I agree to the "),
                                                                            _createElementVNode("a", {
                                                                                class: "tcLink",
                                                                                href: _ctx.config.terms_conditions_url,
                                                                                target: "_blank"
                                                                            }, "terms and conditions", 8, _hoisted_5),
                                                                            _hoisted_6
                                                                        ])
                                                                    ]),
                                                                    _: 1
                                                                }, 8, ["modelValue", "rules"])
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }, 512),
                                        _hoisted_7
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_card_actions, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                            color: "duskBlue",
                                            variant: "flat",
                                            "append-icon": "mdi-send",
                                            block: "",
                                            ripple: "",
                                            loading: submitting.value,
                                            disabled: !formEl.value || !formEl.value.isValid || submitting.value,
                                            onClick: submitRequest
                                        }, {
                                            loader: _withCtx(() => [
                                                _createVNode(_component_v_progress_circular, {
                                                    indeterminate: "",
                                                    color: "white"
                                                })
                                            ]),
                                            default: _withCtx(() => [
                                                _createTextVNode(" Submit ")
                                            ]),
                                            _: 1
                                        }, 8, ["loading", "disabled"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 2
                        }, 1032, ["loading", "disabled"]))
                ]),
                _: 1
            }, 8, ["model-value"]));
        };
    }
});
